import React from 'react';

interface TableColumn {
  header: string;
  key: string;
  width?: string;
}

interface TableProps {
  title?: string;
  columns: TableColumn[];
  data: Record<string, any>[];
  className?: string;
}

export const Table: React.FC<TableProps> = ({ title, columns, data, className = '' }) => {
  return (
    <div className={`my-8 ${className}`}>
      {title && <h3 className="text-2xl font-semibold mb-4">{title}</h3>}
      <div className="overflow-x-auto">
        <table className="min-w-full border-collapse border border-gray-200">
          <thead>
            <tr className="bg-[#EDF2F7]">
              {columns.map((column, index) => (
                <th
                  key={column.key}
                  className="border border-gray-200 px-6 py-4 text-left text-sm font-semibold"
                  style={column.width ? { width: column.width } : {}}
                >
                  {column.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {columns.map((column, colIndex) => (
                  <td
                    key={`${rowIndex}-${column.key}`}
                    className="border border-gray-200 px-6 py-4 text-sm whitespace-pre-wrap"
                  >
                    {row[column.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};